// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-about-jsx": () => import("./../../../src/pages/about.jsx" /* webpackChunkName: "component---src-pages-about-jsx" */),
  "component---src-templates-landing-jsx": () => import("./../../../src/templates/landing.jsx" /* webpackChunkName: "component---src-templates-landing-jsx" */)
}

